import React, { ReactElement } from "react";
import "./styles.scss";

interface CardAlertProps {
  title: string;
  children: ReactElement;
  imgUrl: string;
}

function CardAlert({ imgUrl, title, children }: CardAlertProps) {
  return (
    <div className="cardAlert">
      <div className="containerImage">
        <img src={imgUrl} alt="Section Icon" />
        <div />
      </div>

      <h3>{title}</h3>

      {children}
    </div>
  );
}

export { CardAlert };
